import dayjs from "dayjs";


export const initEECReportFilterData = {
  ScAptTm: dayjs().startOf("month").format("YYYY-MM-01"),
  AptTmSt: dayjs().startOf("month").add(-12, 'month').format("YYYY-MM-01"),
  AptTmEn: dayjs().endOf("month").format("YYYY-MM-DD 23:59:59"),
}